export const SETTINGS_TABS = [
	{ id: "info", label: "Informações gerais" },
	{ id: "pagamentos", label: "Pagamentos" },
	{ id: "frete", label: "Frete e prazos" },
	{ id: "usuarios", label: "Usuários e permissões" },
	{ id: "notificacoes", label: "Notificações" },
	{ id: "integracoes", label: "Integrações" },
] as const;

export type SettingsTabId = (typeof SETTINGS_TABS)[number]["id"];

export const DEFAULT_SETTINGS_TAB: SettingsTabId = "info";

/** Search value from the URL → a known tab (unknown/missing → default). */
export function parseSettingsTab(value: unknown): SettingsTabId {
	return SETTINGS_TABS.some((tab) => tab.id === value)
		? (value as SettingsTabId)
		: DEFAULT_SETTINGS_TAB;
}
